module.exports = {
	"cs": {
		"help-tool": {
			"button-text": "Podpora",
			"support-button": "Získejte podporu",
			"support-page": {
				"create-ticket": {
					"title": "Získejte podporu",
					"instructions": "Odešlete níže uvedenou žádost a my se vám ozveme do 1 pracovního dne.",
					"related-content": {
						"title": "Mohou vám pomoci vyřešit váš problém."
					},
					"fields": {
						"mid": {
							"label": "Vybrat obchod",
							"validation": "Obchod je povinný údaj."
						},
						"phoneNumber": {
							"label": "Telefonní číslo (nepovinné)"
						},
						"topic": {
							"question": "Čeho se vaše otázka týká?",
							"label": "Vyberte téma",
							"validation": "Téma je povinný údaj.",
							"options": {
								"orders": "Objednávky",
								"settlements": "Vypořádání",
								"agreements": "Smlouvy",
								"others": "Jiné"
							}
						},
						"subject": {
							"label": "Předmět",
							"validation": "Předmět je povinný údaj."
						},
						"description": {
							"label": "Zpráva",
							"validation": "Popis je povinný údaj."
						},
						"attachment": {
							"label": "Připojit přílohy",
							"button": "Nahrát",
							"info": "Snímky obrazovky nám tento problém pomohou vyřešit rychleji.",
							"supportedFileTypes": "Typy podporovaných souborů: .png, .jpg, .pdf",
							"error": "Maximální velikost všech souborů je {maxSize} MB."
						}
					},
					"submit": "Odeslat žádost",
					"service-unavailable-error": "Jejda! Něco se nepovedlo, zkuste to znovu za pár minut. V případě pokračování, požádejte o pomoc na {link}.",
					"generic-error": "Vaši žádost se nám nepodařilo zpracovat. Naše systémy spolu momentálně nekomunikují. Zkuste obnovit stránku, nebo se vraťte později. V případě pokračování, požádejte o pomoc na {link}.",
					"contact-link": "kontaktujte nás"
				},
				"view-ticket": {
					"title": "Vše je hotovo!",
					"details": "Vaši žádost jsme obdrželi a odpověď vám zašleme do 1 pracovního dne. Zde jsou detaily:",
					"ticket": "Žádost #{ticketId}",
					"email": "E-mail: {email}",
					"status": "Stav žádosti můžete sledovat na stránce naší podpory.",
					"track": "Sledovat stav"
				}
			},
			"header": {
				"homeLink": "Resetovat"
			},
			"home": {
				"greeting": "Dobrý den, {givenName}! Jak vám můžeme pomoci?",
				"topics": "S čím potřebujete pomoct?"
			},
			"topics": {
				"expandButton": "Více"
			},
			"feedback": {
				"title": "Pomohlo vám to?",
				"optionYes": "Ano, pomohlo mi to",
				"optionNo": "Ne, potřebuji další pomoc",
				"positiveFeedback": "Děkujeme vám za kladnou zpětnou vazbu. Pomůže nám to, abychom vám v budoucnu poskytovali více relevantních článků."
			},
			"freeTextFeedback": {
				"title": "Pomozte nám zlepšovat se",
				"placeholder": "Proč tento obsah nepovažujete za užitečný?",
				"submitButton": "Odeslat",
				"feedbackMessage": "Děkujeme vám za zpětnou vazbu. Pomůže nám to, abychom vám v budoucnu poskytovali více relevantních článků."
			},
			"relatedContent": {
				"title": "Související obsah"
			},
			"search": {
				"buttonLabel": "Hledat",
				"input": "Hledat články…",
				"loading": "Nahrávání…",
				"results": {
					"contact": "Nedaří se vám najít potřebnou nápovědu?",
					"empty": "Litujeme, ale k vašemu dotazu nebyly nalezeny žádné výsledky. Zkuste zadat jiný dotaz.",
					"singleTopicFound": "Našli jsme 1 téma",
					"multipleTopicsFound": "Počet nalezených témat: {count}",
					"singleArticleFound": "Našli jsme 1 článek",
					"multipleArticlesFound": "Počet nalezených článků: {count}"
				}
			},
			"contact": {
				"title": "Kontaktujte nás",
				"channelsIntro": "Obraťte se na nás, abychom vám mohli pomoci.",
				"businessDetailsTitle": "Vaše obchodní údaje",
				"businessDetailsName": "Obchodní jméno",
				"businessDetailsEmail": "E-mail",
				"businessDetailsMid": "ID obchodníka",
				"phone": {
					"title": "Zavolejte nám",
					"paragraph": "Můžete nám zavolat během naší provozní doby ve všední dny. Pokud se nacházíte ve Švédsku nebo ve Spojeném království, můžete nám také zavolat o víkendech od 10:00 do 16:00."
				},
				"email": {
					"title": "Pošlete nám e-mail",
					"paragraph": "Napište nám e-mail a my se vám co nejdříve ozveme."
				}
			},
			"errorBoundary": {
				"title": "Něco se pokazilo",
				"message": "Je nám to moc líto, ale vyskytla se chyba. Vraťte se do nástroje nápovědy tak, že níže kliknete na tlačítko „zpět“, nebo nás kontaktujte pomocí tlačítka „získat podporu“.",
				"resetButton": "Zpět",
				"errorId": "ID chyby: {errorId}"
			},
			"tour": {
				"prev": "Předchozí",
				"next": "Další",
				"done": "Hotovo"
			},
			"notAvailableMobile": {
				"title": "Není k dispozici",
				"buttonBack": "Zpět",
				"paragraph": "Tento obsah není na vašem zařízení dostupný. Zkuste jej otevřít na zařízení s větší obrazovkou, například na počítači."
			},
			"shareButton": {
				"title": {
					"article": "Sdílet odkaz na tento článek",
					"topic": "Sdílet odkaz na toto téma",
					"tour": "Sdílet odkaz na tuto prohlídku"
				},
				"radioItemHome": "Domovská stránka aplikace",
				"descriptionHome": "Otevře článek s nápovědou na domovské stránce portálu obchodníka",
				"radioItemCurrent": "Aktuální stránka",
				"descriptionCurrent": "Otevře článek s nápovědou na aktuální stránce"
			},
			"marketSelector": {
				"whichMarketToContact": "Který trh byste chtěli kontaktovat?"
			}
		},
		"orientation": {
			"title": "Zjistěte, jak…"
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Vážená paní / Vážený pane {name}, 👋 jsem váš asistent Klarna.",
				"whatDoYouNeedHelpWithPart2": "V mnoha případech můžete využít mých služeb k vyřešení vašeho dotazu za méně než 5 minut.",
				"whatDoYouNeedHelpWithPart3": "S čím vám dnes mohu pomoci?",
				"selectSupportChannel": "Vyberte prosím postup kontaktování našich služeb podpory.",
				"selectPayoutIssue": "Skvělé! Pokračujte a vyberte problém související s výplatami 👇",
				"selectOrderIssue": "Skvělé! Pokračujte a vyberte problém související s objednávkami 👇",
				"capturedOrders": "Máte nějaké objednávky {link1}?",
				"capturedOrdersLink1": "zaznamenané",
				"notPaidOrder": {
					"isScheduleFollowed": "Dodržuje se váš {link1} (včetně zpoždění výplaty)?",
					"isScheduleFollowedLink1": "plán plateb",
					"isHoldbackOrDebt": "Pokud zpoždění vyplacení uplynulo, zkontrolujte prosím {link1}. Existuje nějaké zádržné nebo dluh z důvodu vráceného zboží/storna?",
					"isHoldbackOrDebtLink1": "nejnovější soubor vypořádání"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Ověřte si prosím datum zaznamenání objednávek, které jste očekávali, že vám budou vyplaceny, a zohledněte zpoždění vyplacení. Své objednávky naleznete {link1}. Očekává se, že příkazy budou vyplaceny zaznamenané?",
					"isScheduleFollowedLink1": "tady"
				},
				"changePaymentFrequency": "Obdrželi jste více než 30 zaznamenaných objednávek za měsíc v průběhu 3 měsíců?",
				"whenWillGetPaid": "Datum výplaty bude záležet na vašem plánu plateb a zpoždění vyplacení uvedených ve vaší smlouvě (smluvních podmínkách). Pokud si nejste jistí, jak máte výplaty nastavené, můžete si to zkontrolovat v části {link1}. Je dodržován plán plateb (+zpoždění vyplacení)?",
				"whenWillGetPaidLink1": "Vypořádání",
				"thatHelped": "Děkujeme vám za kladnou zpětnou vazbu. Pomůže nám, abychom vám v budoucnu poskytovali relevantnější pomoc. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Aha, už rozumím! Máte nějaké nezaznamenané objednávky?",
					"haveUncapturedOrdersPart2": "Pokud nevíte, jak to zkontrolovat, přejděte prosím na {link1}.",
					"haveUncapturedOrdersPart2Link1": "tuto stránku",
					"expirationDateSurpassed": "Uplynulo datum konce platnosti (obvykle 28 dní)",
					"customerCreditPaymentMethod": "Zvolil zákazník způsob platby (faktura, účet, bezhotovostní úhrada)?",
					"isOrderCaptured": "Je objednávka {link1}?",
					"isOrderCapturedLink1": "zaznamenaná"
				}
			},
			"options": {
				"payout": "Vyplacená částka",
				"orders": "Objednávky",
				"otherIssue": "Jiné problémy",
				"whenPaidOrderNext": "Kdy dostanu příště zaplaceno?",
				"notPaidOrder": "Nedostal/a jsem zaplaceno",
				"paidWrongAmount": "Byla mi zaplacena špatná částka",
				"changeHowOftenPaid": "Chci změnit frekvenci plateb",
				"dontKnowHowToCaptureOrder": "Nevím, jak zaznamenat objednávku",
				"missedCaptureDeadline": "Zmeškal/a jsem lhůtu pro zaznamenání",
				"needToRefundAnOrder": "Potřebuji refundovat objednávku",
				"yes": "Ano",
				"no": "Ne",
				"partially": "Částečně",
				"iNeedMoreHelp": "Potřebuji další pomoc",
				"thatHelped": "Pomohlo to",
				"contactSupportChannel": "Kontaktovat kanály podpory"
			},
			"explanations": {
				"noCapturedOrders": "Nejprve je třeba {link1}. Po zaznamenání objednávky vám vyplatíme částku na váš bankovní účet. Poplatky, vrácené zboží a jiné změny budou odečteny od vyplacené částky.",
				"noCapturedOrdersLink1": "zaznamenání objednávky",
				"feesReturnsHoldbacks": "Poplatky, vrácení a jiné platby mohou být odečteny od vyplacené částky. Zkontrolujte prosím, zda máte nějaké zádržné částky nebo dluh z důvodu vrácení/storna v {link1}.",
				"feesReturnsHoldbacksLink1": "nejnovějším souboru vypořádání",
				"notPaidOrder": {
					"scheduleFollowed": "Po zaznamenání objednávky vám vyplatíme částku na váš bankovní účet podle vašeho plánu plateb. Poplatky, vrácené zboží a jiné změny budou odečteny od vyplacené částky. Zkontrolujte si prosím hodnotu výplaty v {link1}.",
					"scheduleFollowedLink1": "nejnovějším souboru vypořádání",
					"noHoldback": "Ověřte prosím, zda máte zaregistrované správné údaje o bankovním účtu pro měnu výplaty {link1}.",
					"noHoldbackLink1": "tady",
					"withHoldback": "Pokud hodnota zaznamenaných objednávek převyšuje dluh, ověřte prosím, zda máte zaregistrované správné údaje o bankovním účtu pro měnu výplaty {link1}.",
					"withHoldbackLink1": "tady"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Další výplatu obdržíte podle plánu plateb + zpoždění vyplacení."
				},
				"changePaymentFrequency": {
					"isAble": "Pokračujte prosím kontaktováním podpory prostřednictvím níže uvedených kanálů.",
					"isUnable": "Bohužel nesplňujete podmínky pro změnu plánu plateb."
				},
				"orders": {
					"uncapturedDynamicYes": "Jejda, vidím, že máte {number} nezaznamenaných objednávek.",
					"uncapturedDynamicNo": "Jejda, vidím, že máte nezaznamenané objednávky.",
					"uncapturedYesPart1": "Je tedy na čase, abyste zaznamenali nějaké objednávky! Postupujte takto:",
					"uncapturedYesPart2": "1. Přejděte na stránku Objednávky {link1}.",
					"uncapturesYesPart2Link1": "kliknutím sem",
					"uncapturedYesPart3": "2. Klikněte na referenci Klarna u objednávky, kterou chcete zaznamenat.",
					"uncapturedYesPart4": "3. Vyberte zboží nebo přidejte částku, kterou chcete zaznamenat.",
					"uncapturedYesPart5": "4. Stiskněte „Zaznamenat“",
					"uncapturedNoPart1": "Chcete-li zaznamenat objednávku, musíte nejprve mít objednávky k zaznamenání.",
					"uncapturedNoPart2": "Při zaznamenání objednávky se jedná o potvrzení, že objednávka byla zákazníkovi odeslána. U každé objednávky by se to mělo vždy uskutečnit ve stejný den, kdy je objednávka odeslána. Při zaznamenání objednávky nám také dáte vědět, že bychom vám měli za tuto objednávku vyplatit peníze. Přečtěte si více o tom, jak zaznamenat objednávku {link1}.",
					"uncapturedNoLink1": "tady",
					"customerCreditPaymentMethodNo": "Objednávku, jejíž platnost vypršela, bohužel nemůžeme prodloužit. Objednávku budete muset vytvořit znovu.",
					"expirationDateSurpassedYes": "Pomůžeme vám rozšířit objednávku, kontaktujte prosím naši podporu prostřednictvím jednoho z níže uvedených kanálů.",
					"expirationDateSurpassedNo": "Přejděte na {link1}. Objednávku vyberete zaškrtnutím políčka vedle referenčního čísla Klarna. Klikněte na tlačítko Prodloužit datum konce platnosti a potvrďte svůj požadavek.",
					"expirationDateSurpassedNoLink1": "Objednávky > K zaznamenání",
					"isOrderCapturedYesPart1": "Vyberte položky, které chcete vrátit, a klikněte na tlačítko Refundovat. Můžete také nejprve kliknout na tlačítko Refundace a poté zadat částku, kterou chcete refundovat – sami si zvolte, který způsob vám vyhovuje lépe.",
					"isOrderCapturedYesPart2": "Zákazníkovi bude znovu zaplacena částka, kterou již zaplatil, do 2 až 5 pracovních dní. A tato částka se odečte od vaší příští výplaty.",
					"isOrderCapturedNo": "Pokud máte nezaznamenanou objednávku, kterou nechcete odeslat, můžete celou objednávku {link1}. Přejděte na {link2} a klikněte na Zrušit objednávku.",
					"isOrderCapturedNoLink1": "zrušit",
					"isOrderCapturedNoLink2": "stránku objednávky",
					"refundPartiallyCaptured": "Pokud jste částečně zaznamenali objednávku pro zaslané položky a zbytek nebudete plnit, měli byste nezaznamenanou část objednávky vydat. Přejděte na {link1}, klikněte na Další akce a vyberte Uvolnit.",
					"refundPartiallyCapturedLink1": "stránku objednávky"
				}
			},
			"messages": {
				"sorryToHearThat": "Je nám líto, že to nebylo užitečné. Zakrátko budete přesměrováni na kontaktování podpory."
			},
			"button": {
				"label": "Získejte podporu"
			},
			"contact": {
				"chat": "Chat se zástupcem",
				"ticket": "Odeslat lístek",
				"times": {
					"minutes": "Doba čekání: {time} minut",
					"hours": "Doba čekání: {time} hodin",
					"days": "Doba čekání: {time} dní"
				}
			}
		}
	}
};